import React from 'react';
import ImageUploading from 'react-images-uploading';
import {ValidatorComponent} from 'react-material-ui-form-validator';
import {Box, withStyles} from '@material-ui/core';
import {styles} from './styles';

/**
 * class to render image uploading validator
 * @returns {JSX.Element}
 */
class ImageUploadingValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const {
      value,
      errorMessages,
      validators,
      validatorListener,
      ...rest
    } = this.props;

    return (
      <Box>
        <ImageUploading {...rest} />
        {this.errorText()}
      </Box>
    );
  }

  errorText() {
    const {isValid} = this.state;
    const {classes} = this.props;

    if (isValid) {
      return null;
    }

    return <Box className={classes.text}>{this.getErrorMessage()}</Box>;
  }
}

export default withStyles(styles)(ImageUploadingValidator);
